export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Motorcycle technicians, mechanics, workshop professionals and serious motorcycle repairers.',
  },
  {
    question: 'Is this a physical product?',
    answer:
      'No. MOTORCYCLE DIAGNOSTIC PRO™ is a 100% digital resource.',
  },
  {
    question: 'Is this a training course or certification?',
    answer:
      'No. It is a practical professional diagnostic reference and troubleshooting system.',
  },
  {
    question: 'Is it another theory-heavy ebook?',
    answer:
      'No. It focuses on visual references, diagnostic workflows, troubleshooting paths, electrical testing and practical fault-finding tools.',
  },
  {
    question: 'What areas are included?',
    answer:
      'Engine and starting, fuel and intake, electrical and charging, ignition and electronics, drivetrain and chassis, and complete fault finding.',
  },
  {
    question: 'Does this replace manufacturer procedures?',
    answer:
      'No. Always follow manufacturer specifications, service information and applicable workshop safety procedures.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
  {
    question: 'Does it work for any motorcycle brand or model?',
    answer:
      'The system is organized by symptom and by system — engine, fuel, electrical, electronics, drivetrain and chassis — so the diagnostic workflows apply across brands and models. Specific values and procedures must always be confirmed against the manufacturer service information for the bike in front of you.',
  },
  {
    question: 'Do I need special diagnostic equipment to use it?',
    answer:
      'No. The electrical and electronic sections are built around common workshop tools such as a multimeter, basic test leads and standard measuring procedures. Where scan-tool data or DTCs are involved, the system shows how to interpret that information and what to test next.',
  },
  {
    question: 'Can I use it on a phone or tablet in the workshop?',
    answer:
      'Yes. It is a digital resource you can open on a phone, tablet, laptop or desktop, so the diagnostic workflows and references stay available at the bench while you work.',
  },
]
